// removed by extract-text-webpack-plugin
module.exports = {"vpDrawerLink":"vpDrawerLink___3WjNy","vpActiveLink":"vpActiveLink___11-ta"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/OrganizationMenu.module.less
// module id = 3228
// module chunks = 33